export default {
    openSendTab(linkedType, linkedId, params = {}) {
        if (!linkedType || !linkedId) {
            throw Error('Linked id or type missing');
        }

        let route = `/rest/email/sending?linkedtype=${linkedType}&linkedid=${linkedId}`;

        SellsyJS.WebServiceCaller.get(
            route,
            params,
            (response) => {
                if (response.access) {
                    eval(response.action);
                } else {
                    let key = `email${
                        response.action[0].toUpperCase() + response.action.substring(1)
                    }`;
                    let callbackPath = window.location.pathname + window.location.search;
                    let params = `emailprocess[linkedtype]=${linkedType}&emailprocess[linkedid]=${linkedId}`;
                    callbackPath = encodeURIComponent(
                        callbackPath + (callbackPath.indexOf('?') > 0 ? '&' : '?') + params,
                    );

                    window.sellsyapp.config.globalProperties.$store.state.popupPanel[key].props = {
                        callback: callbackPath,
                    };
                    window.sellsyapp.config.globalProperties.$store.state.popupPanel[
                        key
                    ].display = true;
                }
            },
            (error) => {
                Push.error(
                    this.$l10n.__(
                        'Une erreur est survenue lors de la vérification du compte email.',
                    ),
                    false,
                );
            },
        );
    },
};
